import { useTranslation } from 'react-i18next';

export default function LegalPage({ ns }) {
  const { t } = useTranslation();
  const keys = {
    privacy: ['introTitle', 'introBody', 'dataTitle', 'dataBody', 'purposeTitle', 'purposeBody', 'legalTitle', 'legalBody', 'retentionTitle', 'retentionBody', 'rightsTitle', 'rightsBody', 'sharingTitle', 'sharingBody', 'childrenTitle', 'childrenBody', 'changesTitle', 'changesBody'],
    cookiepol: ['introTitle', 'introBody', 'consentModeTitle', 'consentModeBody', 'typesTitle', 'typesBody', 'controlTitle', 'controlBody', 'retentionTitle', 'retentionBody', 'thirdTitle', 'thirdBody'],
    terms: ['introTitle', 'introBody', 'serviceTitle', 'serviceBody', 'eligibilityTitle', 'eligibilityBody', 'riskTitle', 'riskBody', 'ipTitle', 'ipBody', 'conductTitle', 'conductBody', 'liabilityTitle', 'liabilityBody', 'lawTitle', 'lawBody', 'contactTitle', 'contactBody'],
  };
  const list = keys[ns];
  // Group as [title, body] pairs
  const pairs = [];
  for (let i = 0; i < list.length; i += 2) pairs.push([list[i], list[i + 1]]);

  return (
    <main className="pt-[72px]">
      <div className="max-w-[880px] mx-auto px-5 md:px-10 py-16 md:py-24">
        <div className="text-[11px] uppercase tracking-[0.18em] text-[#0B1E3F]/50">Zyvanelix</div>
        <h1 className="mt-3 font-serif text-[38px] md:text-[54px] leading-[1.08] font-semibold text-[#0B1E3F] tracking-[-0.01em]">{t(`${ns}.title`)}</h1>
        <div className="mt-3 text-[13px] text-[#0B1E3F]/60">{t(`${ns}.updated`)}</div>

        <div className="mt-10 space-y-8 text-[15.5px] leading-[1.8] text-[#0B1E3F]/80">
          {pairs.map(([titleKey, bodyKey]) => (
            <section key={titleKey}>
              <h2 className="font-serif text-[22px] md:text-[26px] font-semibold text-[#0B1E3F] mb-3">{t(`${ns}.${titleKey}`)}</h2>
              <p>{t(`${ns}.${bodyKey}`)}</p>
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}
